import React, { useState } from "react";
import css from "@/src/pages/map/.module.scss";
import { Spinner } from "@aqar-app/aqar-design-system";
import { Listing } from "@/src/components/Listing/ListingCard";
import { DrawingButton } from "@/src/components/map/map";
import { DropDown } from "@aqar-app/react-ui";
import { Icon } from "@/components/icon";
import { usePath } from "@/contexts/path/path";
import { trackGenericCTAClickEvent } from "@/lib/tracking/trackNavigationEvents";

export function List(
  { listings, total, loading, fetchMore, setListing } = {
    listings: [],
  },
) {
  const [loadedListing, setLoadedListing] = useState([]);

  if (loading)
    return (
      <div className={css.spinnerWrapper}>
        <Spinner className={css.spinner5rem} />
      </div>
    );

  const fetchNextPage = () => {
    return fetchMore({
      variables: {
        from: loadedListing?.length,
      },
    }).then((res) => {
      const { listings } = res?.data?.Web?.find || { listings: [] };
      setLoadedListing((prev) => [...prev, ...listings]);
    });
  };

  const handleScroll = ({ currentTarget }, cb) => {
    if (
      currentTarget.scrollTop + currentTarget.clientHeight >=
        currentTarget.scrollHeight &&
      !loading &&
      loadedListing.length < total
    ) {
      cb();
    }
  };

  return (
    <div className={css.listLayer}>
      <div
        className={css.ListContainer}
        onScroll={(e) => handleScroll(e, fetchNextPage)}
      >
        {listings.map((listing, index) => (
          <Listing
            onClick={() => setListing(listing)}
            key={listing.id}
            index={index}
            listing={listing}
          />
        ))}
        {loadedListing.map((listing, index) => (
          <Listing
            onClick={() => setListing(listing)}
            key={listing.id}
            index={index}
            listing={listing}
          />
        ))}
      </div>
    </div>
  );
}
export function MapControls({
  setMode,
  map,
  mode,
  mapType,
  setMapType,
  children,
  onPolygonDrawn,
}) {
  const { category, listingType } = usePath();

  const sharedEventParams = {
    listing_type: listingType,
    property_category: category?.en,
  };

  return (
    <div className={css.controls}>
      <button
        type="button"
        onClick={() => {
          if (mode !== "FLOATING_LIST") {
            trackGenericCTAClickEvent("listings_list_view", sharedEventParams);
            return setMode("FLOATING_LIST");
          }
          trackGenericCTAClickEvent("listings_map_view", sharedEventParams);
          setMode("DEFAULT");
        }}
      >
        <Icon
          name={
            mode === "FLOATING_LIST" ? "MapSearch-colored" : "Listings-ListView"
          }
          height={20}
          width={20}
        />
        {mode === "FLOATING_LIST" ? "عرض كخريطة" : "عرض كقائمة"}
      </button>

      <DrawingButton
        map={map}
        drawingClassName={css.drawing}
        isDrawing={mode === "DRAWING"}
        setIsDrawing={(value) => {
          setMode(value ? "DRAWING" : "DEFAULT");
        }}
        onPolygonDrawn={onPolygonDrawn}
      />
      <DropDown
        zIndex={100}
        placement="right-start"
        overlay={
          <div className={css.mapDropDown}>
            <button
              onClick={() => {
                setMapType("roadmap");
                map.setMapTypeId("roadmap");
                trackGenericCTAClickEvent("map_default", sharedEventParams);
              }}
              type="button"
              className={mapType === "roadmap" && css.active}
            >
              تلقائي
            </button>
            <button
              onClick={() => {
                setMapType("satellite");
                map.setMapTypeId("satellite");
                trackGenericCTAClickEvent("map_satellite", sharedEventParams);
              }}
              className={mapType === "satellite" && css.active}
              type="button"
            >
              القمر الصناعي
            </button>
            <button
              onClick={() => {
                setMapType("terrain");
                map.setMapTypeId("terrain");
                trackGenericCTAClickEvent("map_terrain", sharedEventParams);
              }}
              className={mapType === "terrain" && css.active}
              type="button"
            >
              تضاريس
            </button>
          </div>
        }
      >
        <button>
          <Icon name="basemap-type" height={20} width={20} />
          نوع الخريطة
        </button>
      </DropDown>
      {children}
    </div>
  );
}
